import { cn } from "~/common/cn"
import loaderIcon from "~/images/icons/loader-icon"

type LoadingIndicatorProps = {
  className?: string
  size?: "small"
}

export const LoadingIndicator = (props: LoadingIndicatorProps) => (
  <div role="status">
    <div aria-hidden="true" className={cn("animate-spin", props.className)}>
      <img {...loaderIcon} alt="" />
    </div>
    <span className="sr-only">Loading...</span>
  </div>
)
